import React, { useEffect } from "react";
import Header from "./Header";
import CreateDashboard from "./CreateDashboard";
import HeaderDashboard from "../HeaderDashboard";
const DashboardMain = () => {
  // to skip the reload,as the script still needs to reloaded manually, after every build
  // useEffect(() => {
  //   const scripts = document.querySelectorAll("script");
  //   if (!localStorage.getItem("hasReloaded")) {
  //     // Clear localStorage or any other state as needed
  //     if ("caches" in window) {
  //       caches.keys().then((cacheNames) => {
  //         cacheNames.forEach((cacheName) => {
  //           caches.delete(cacheName);
  //         });
  //       });
  //     }
  //     localStorage.clear();

  //     // Set a flag to prevent further reloads
  //     localStorage.setItem("hasReloaded", "true");

  //     // Force reload without using cache
  //     window.location.reload(true); // Passing 'true' forces a hard reload
  //   }
  // }, []);
  return (
    <>
      <div className="flex flex-col gap-1 h-full justify-around">
        <HeaderDashboard />
        <div className="ps-5 pe-32 w-full">
          <CreateDashboard />
        </div>
      </div>
    </>
  );
};
export default DashboardMain;
